<div class="main-content">
    <div class="flex items-center">
        <span class="cam-name" (click)="previousPage()">
            {{cam?.alias}}
        </span>
        <span class="analytic-name" nz-icon nzType="right" nzTheme="outline"></span>
        <span class="analytic-name">{{ !analytic ? 'Nova detecção inteligente' : 'Detecção inteligente'}} de {{namePage}}</span>
    </div>
    <div class="card_image flex flex-row justify-between">
        <!-- Imagem -->
        <div class="grid-draw">
            <app-draw-analytic [optionsAnalytics]="optionsAnalytics" [camera]="cam" [analytic]="analytic"
                [drawType]="changedOptionEvent.asObservable()"
                [resetAnalytic]="resetAnalyticEvent.asObservable()"
                [analyticFormInformation]="formInformation.asObservable()">
            </app-draw-analytic>
        </div>
        <!-- INÍCIO PAINEL DE CONFIGURAÇÕES -->

        <div class="grid-controller">
            <app-configure-analytic (setFullForm)="getAnalyticFormFull($event)"
                [optionsAnalytics]="optionsAnalytics" [analytic]="analytic" [loading]="loadingPostDel"
                [resetAnalytic]="resetAnalyticEvent.asObservable()" [groupAnalytic]="groups"
                (analyticDraw)="changedOption($event)" (chosenAnalytic)="getChosenAnalytic($event)"
                (cancelEmit)="previousPage()" (saveEmit)="addAnalytic()" [isHolidayActive]="hasHolidaysInCamera"
                [cameraData]="{id: cam.id, name: cam.alias}"></app-configure-analytic>
        </div>
    </div>
</div>
